import { UpdateWorkspaceSideBar } from "./UpdateWorkspaceSideBar";

export default UpdateWorkspaceSideBar;
